import { useEffect } from 'react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { CheckinState } from './model/CheckinState';
import { HistoryViewModel } from '../support/HistoryViewModel';
import { IFeeling } from './model/ICheckin';

// This "page" handles /daily-log route
export const ShowCheckin: React.FC = () => {
    const checkinState = useInstance(CheckinState);
    const history = useInstance(HistoryViewModel);

    useEffect(() => {
        const params = history.getCurrentSearchParamMap();

        // this is stripping the query param
        if (params.feeling) {
            history.replace(history.getCurrentLocation().pathname);
        }

        const feeling = (params.feeling in IFeeling ? Number(params.feeling) : undefined);

        checkinState.startEditing({ feeling, trackingFrom: 'caregiver corner' });

    }, [checkinState, history]);

    return null;
};
